import styled from 'styled-components/macro'

export const Bar = styled.div<{ loadingPercent?: number }>`
  width: ${(props) => (props.loadingPercent ? `${props.loadingPercent}%` : `100%`)};
  background: ${(props) => (props.loadingPercent ? `linear-gradient(90deg, #9542FF 0%, #3AD8ED 100%);` : `#38383D;`)};
  border-radius: 15px;
  height: 12px;
`
